<template>
  <div class="card-area">
    <form novalidate class="md-layout">
      <md-card class="md-layout-item md-size-50 md-small-size-100">
        <div class="md-title">Secure ID Verify</div>

        <md-card-header>
          <div class="md-title">Step 3 of 4</div>
        </md-card-header>
        <div class="md-title" v-if="!isPhotoTaken">
          Take a clear photo of your ID
        </div>
        <div class="md-title" v-if="isPhotoTaken && isCameraOpen">
          Check the photo – is the ID clear and not cropped?
        </div>
        <div id="app" class="web-camera-container">
          <div v-show="isCameraOpen && isLoading" class="camera-loading">
            <ul class="loader-circle">
              <li></li>
              <li></li>
              <li></li>
            </ul>
          </div>

          <div
            v-if="isCameraOpen"
            v-show="!isLoading"
            class="camera-box"
            :class="{ flash: isShotPhoto }"
          >
            <div class="camera-shutter" :class="{ flash: isShotPhoto }"></div>

            <video
              v-show="!isPhotoTaken"
              ref="camera"
              :width="450"
              :height="337.5"
              autoplay
            ></video>

            <canvas
              v-show="isPhotoTaken"
              id="photoTaken"
              ref="canvas"
              :width="450"
              :height="337.5"
            ></canvas>
          </div>

          <div v-if="isCameraOpen && !isLoading" class="camera-shoot">
            <button
              type="button"
              class="button"
              @click="takePhoto"
              v-if="!isPhotoTaken"
            >
              <img
                src="https://img.icons8.com/material-outlined/50/000000/camera--v2.png"
              />
            </button>
          </div>
          <md-button
            class="md-raised"
            v-if="isPhotoTaken && isCameraOpen"
            @click="takePhoto"
            >re-take photo</md-button
          >
          <div v-if="isPhotoTaken && isCameraOpen" class="camera-download">
            <md-button
              id="downloadPhoto"
              download="my-photo.jpg"
              role="button"
              class="md-raised md-primary"
              v-if="isPhotoTaken && isCameraOpen"
              @click="downloadImage"
              >it’s clear – next></md-button
            >
          </div>
        </div>
      </md-card>
    </form>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
export default {
  name: "TakePhoto",
  props: {
    msg: String,
  },
  mixins: [validationMixin],
  data: () => ({
    form: {
      sixcode: null,
    },
    isCameraOpen: true,
    isPhotoTaken: false,
    isShotPhoto: false,
    isLoading: false,
    link: "#",
  }),

  mounted() {
    this.createCameraElement();
  },
  methods: {
    toggleCamera() {
      if (this.isCameraOpen) {
        this.isCameraOpen = false;
        this.isPhotoTaken = false;
        this.isShotPhoto = false;
        this.stopCameraStream();
      } else {
        this.isCameraOpen = true;
        this.createCameraElement();
      }
    },

    createCameraElement() {
      this.isLoading = true;

      const constraints = (window.constraints = {
        audio: false,
        video: true,
      });

      navigator.mediaDevices
        .getUserMedia(constraints)
        .then((stream) => {
          this.isLoading = false;
          this.$refs.camera.srcObject = stream;
        })
        .catch((error) => {
          this.isLoading = false;
          alert(
            "May the browser didn't support or there is some errors." + error
          );
        });
    },

    stopCameraStream() {
      let tracks = this.$refs.camera.srcObject.getTracks();

      tracks.forEach((track) => {
        track.stop();
      });
    },

    takePhoto() {
      if (!this.isPhotoTaken) {
        this.isShotPhoto = true;

        const FLASH_TIMEOUT = 50;

        setTimeout(() => {
          this.isShotPhoto = false;
        }, FLASH_TIMEOUT);
      }

      this.isPhotoTaken = !this.isPhotoTaken;
      const context = this.$refs.canvas.getContext("2d");
      context.drawImage(this.$refs.camera, 0, 0, 450, 337.5);
    },

    downloadImage() {
      // const download = document.getElementById("downloadPhoto");
      // const canvas = document
      //   .getElementById("photoTaken")
      //   .toDataURL("image/jpeg")
      //   .replace("image/jpeg", "image/octet-stream");
      // console.log("sucess Image");
      // download.setAttribute("href", canvas);
      this.$router.push({ name: "VideoDetail" });
    },
  },
};
</script>

<style lang="css" scoped>
/* .md-progress-bar {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
}

.md-card-actions {
  flex-direction: column;
}

.md-card-actions .md-button {
  margin-top: 20px !important;
  padding: 10px;
}

.text_content {
  padding: 10px;
}

.footer {
  margin-top: 20px;
  padding: 10px;
  font-size: 120%;
}

.md-card {
  display: inline-block;
  padding: 20px;
}

.card-area {
  align-items: center;
  justify-content: center;
  background: #ddd;
}
.md-primary {
  background-color: green;
  color: white !important;
}

.md-layout-item.md-size-50 {
  min-width: 80%;
  max-width: 70%;
}
@import url("https://fonts.googleapis.com/css?family=Sarala");
body {
  width: 100vw;
  height: 100vh;
  background-color: #282c34;
  display: flex;
  align-items: center;
  justify-content: center;
}

h1 {
  color: #fff;
  font-family: Sarala, Arial, sans-serif;
  font-size: 22px;
  text-transform: uppercase;
  text-align: center;
  margin-bottom: 30px;
}

#container {
  max-width: 80vw;
  max-height: 80vh;
  position: relative;
}

#player {
  width: 100%;
  border: 2px solid #111;
  box-shadow: 0 0 50px #111;
}

#capture-button {
  display: block;
  position: absolute;
  width: 50px;
  height: 50px;
  bottom: 20px;
  left: 50%;
  margin-left: -25px;
  border-radius: 50%;
  background-color: #ff0000;
  border: 2px solid #fff;
  cursor: pointer;
  transition: all 0.15s ease-in-out;
  opacity: 0.5;
  outline: none;
}
#capture-button:hover {
  transform: scale(1.1);
}
#capture-button:active {
  background-color: #00ff00;
}

#output {
  display: none;
} */
</style>
